(function () {
  document.addEventListener('DOMContentLoaded', function () {
    if (!/\/products\//.test(location.pathname)) return;

    // ---- Config / elements ----
    var API_BASE =
      (document.getElementById('bid-inline')?.getAttribute('data-api-base') ||
       (window.staAuctionsBase ? window.staAuctionsBase() : localStorage.getItem('sterlings_base_url')) || '').replace(/\/+$/,'');
    if (!API_BASE) console.warn('[bid] Missing API base; set shop.metafields.custom.auctions_api_base or localStorage.sterlings_base_url');

    var auctionHeaders = window.staAuctionHeaders ? window.staAuctionHeaders() : { Accept: 'application/json' };

    var PRODUCT_GID   = null;
    var BID_LOT       = window.staBidLot || {};
    var PRODUCT_TITLE = BID_LOT.title || '';
    var PRODUCT_IMAGE = BID_LOT.image || '';

    var actionsWrap = document.getElementById('place-bid');
    if (!actionsWrap) return;

    function attrsFromAuctionPayload(a) {
      var data = a && a.data && !Array.isArray(a.data) ? a.data : a;
      return (data && data.attributes) ? data.attributes : (data || {});
    }

    function isAuctionClosedByApi(attrs) {
      if (!attrs) return false;
      var st = String(attrs.status || '').toLowerCase();
      if (/disabled|ended|archive|complete|cancel/.test(st)) return true;
      var endIso = attrs.end_date || attrs.end_at;
      if (endIso && Date.parse(endIso) <= Date.now()) return true;
      return false;
    }

    function disableBiddingForEndedAuction(message) {
      var inlineWrap = document.getElementById('bid-inline');
      var btnPlace = actionsWrap.querySelector('.product-price__to-cart');
      var loginBtn = actionsWrap.querySelector('.sta-btn.login');
      if (inlineWrap) inlineWrap.style.display = 'none';
      if (btnPlace) {
        btnPlace.classList.add('hidden');
        btnPlace.disabled = true;
      }
      if (loginBtn) loginBtn.classList.add('hidden');
      if (!actionsWrap.querySelector('[data-sta-auction-bidding-closed]')) {
        var note = document.createElement('p');
        note.setAttribute('data-sta-auction-bidding-closed', 'true');
        note.className = 'bid-inline__msg bid-inline__msg--err';
        note.style.marginTop = '0';
        note.textContent = message || 'This auction has ended. Bidding is closed.';
        actionsWrap.insertBefore(note, actionsWrap.firstChild);
      }
    }

    function maybeGateByUrlAuctionIdThen(initFn) {
      var auctionId = window.staResolveAuctionId ? window.staResolveAuctionId() : '';
      try {
        if (!auctionId) {
          auctionId = new URL(location.href).searchParams.get('auction_id') || '';
        }
      } catch (e) {}
      if (!auctionId || !API_BASE) {
        initFn();
        return;
      }

      var customerId = window.staCurrentCustomerId ? window.staCurrentCustomerId() : '';
      var showPath = window.staAuctionShowPath
        ? API_BASE + window.staAuctionShowPath(auctionId, customerId)
        : API_BASE + '/api/auctions/' + encodeURIComponent(auctionId);

      fetch(showPath, {
        headers: auctionHeaders,
        mode: 'cors',
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (payload) {
          if (isAuctionClosedByApi(attrsFromAuctionPayload(payload))) {
            disableBiddingForEndedAuction();
            return;
          }
          initFn();
        })
        .catch(function () {
          initFn();
        });
    }

    var priceEl     = document.querySelector('[data-sta-auction-live-price]');
    var bidsCountEl = document.querySelector('.product-price__bids-count');

    function setBidsCount(count) {
      if (!bidsCountEl) return;
      var n = parseInt(count, 10) || 0;
      bidsCountEl.textContent = n + ' ' + (n === 1 ? 'Bid' : 'Bids');
    }

    function refreshBidsCountFromShow(auctionId) {
      var customerId = window.staCurrentCustomerId ? window.staCurrentCustomerId() : '';
      var showPath = window.staAuctionShowPath
        ? API_BASE + window.staAuctionShowPath(auctionId, customerId)
        : API_BASE + '/api/auctions/' + encodeURIComponent(auctionId);
      return fetch(showPath, { headers: auctionHeaders, mode: 'cors' })
        .then(function (r) {
          if (!r.ok) return;
          return r.json();
        })
        .then(function (payload) {
          if (!payload) return;
          var attrs = attrsFromAuctionPayload(payload);
          var bids = attrs.bids_count != null ? attrs.bids_count : attrs.bid_count;
          if (bids == null) return;
          var displayed = parseInt((bidsCountEl && bidsCountEl.textContent || '').replace(/\D/g, ''), 10) || 0;
          if (bids >= displayed) setBidsCount(bids);
        })
        .catch(function () {});
    }

    function formatLike(el, amount) {
      if (window.staFormatMoneyPlain) return window.staFormatMoneyPlain(amount);
      return '$' + amount + ' CAD';
    }


    // ---- Helpers ----
    function extractPrice(el) {
      if (!el) return 0;
      // Only the CAD amount: the element also holds the "≈ $4 USD" line, whose
      // digits would otherwise be read on the end ($5 CAD ≈ $4 USD → 54). Both
      // the Liquid render and staSetMoneyEl put that line in .sta-money__approx.
      var copy = el.cloneNode(true);
      copy.querySelectorAll('.sta-money__approx').forEach(function (approx) { approx.remove(); });
      var txt = copy.textContent || '';
      var n = parseFloat(txt.replace(/[^0-9.]/g, '')) + 1;
      // bids are whole dollars only — round up so the minimum is never below the current price
      return isFinite(n) ? Math.ceil(n) : 0;
    }

    function pickArray(payload){
      if (Array.isArray(payload?.items)) return payload.items;
      if (Array.isArray(payload?.data))  return payload.data;
      if (Array.isArray(payload?.data?.data)) return payload.data.data;
      if (Array.isArray(payload)) return payload;
      return [];
    }
    function attr(it,k){ return it?.attributes ? it.attributes[k] : it?.[k]; }

    /**
     * Swap "Place bid" for a link to verification when this shopper is not
     * verified. Cosmetic only — the real check is server-side in the bid gate,
     * so a shopper who defeats this still cannot bid. It exists so the refusal
     * arrives before someone types an amount, not after.
     */
    /** Where "Update card" goes: the Replace card flow, back to this lot after. */
    function replaceCardUrl() {
      var routes = window.STA_ROUTES || {};
      var base = (routes.verify || '/pages/verify-to-bid') + '?replace=1';
      return window.staReturn
        ? window.staReturn.withReturn(base, window.staReturn.currentPath())
        : base;
    }

    function swapButtonForLink(btnPlace, href, label) {
      var link = document.createElement('a');
      link.className = btnPlace.className;
      link.href = href;
      link.textContent = label;
      btnPlace.parentNode.replaceChild(link, btnPlace);
    }

    /**
     * Sets the bid button from the customer's verification and card state.
     * Cosmetic only — the bid gate enforces all of this server-side, so a
     * shopper who defeats it still cannot bid. It exists so the refusal comes
     * before someone types an amount, not after.
     *
     * The client's rule (2026-09-16): every card on file gets the expiry
     * warnings, but an expired card only blocks bidding when the card is what
     * verified the customer. The app decides that and reports it as
     * card.blocks_bidding, so the rule lives in one place.
     */
    function applyVerificationGate(btnPlace) {
      if (!window.staBidderStatus) return;

      window.staBidderStatus().then(function (status) {
        // null means unknown — signed out, or the app did not answer. Leave the
        // button alone rather than wrongly demanding verification.
        if (!status) return;

        if (status.is_verified === false) {
          // Carries this lot so verification ends back here, ready to bid.
          swapButtonForLink(
            btnPlace,
            window.staReturn
              ? window.staReturn.verifyUrl(window.staReturn.currentPath())
              : '/pages/verify-to-bid',
            'Get verified to bid'
          );
          return;
        }

        var card = status.card;
        if (!card || !card.last4) return;

        // Still verified — they only need a card that can be charged.
        if (card.blocks_bidding) {
          swapButtonForLink(btnPlace, replaceCardUrl(), 'Update card to bid');
          return;
        }

        // Bidding allowed, but tell them before it becomes a problem.
        if (card.expired || card.expiring_soon) {
          var note = document.createElement('p');
          note.className = 'bid-inline__msg' + (card.expired ? ' bid-inline__msg--err' : '');
          note.setAttribute('data-sta-card-expiry-note', '');
          note.textContent = card.expired
            ? 'Your card on file has expired. '
            : 'Your card on file expires soon. ';

          var update = document.createElement('a');
          update.href = replaceCardUrl();
          update.textContent = 'Update card';
          note.appendChild(update);

          btnPlace.parentNode.insertBefore(note, btnPlace.nextSibling);
        }
      });
    }

    function initPlaceBidUi() {
      var btnPlace = actionsWrap.querySelector('.product-price__to-cart');
      if (!btnPlace) return;

      applyVerificationGate(btnPlace);

      var customerId = btnPlace.getAttribute('data-customer-id') || '';
      var first = btnPlace.getAttribute('data-first-name') || '';
      var last  = btnPlace.getAttribute('data-last-name') || '';
      var email = btnPlace.getAttribute('data-customer-email') || '';

      var inlineWrap  = document.getElementById('bid-inline');
      var inputAmount = document.getElementById('bid-inline-amount');
      var btnOk       = document.getElementById('bid-inline-ok');
      var btnCancel   = document.getElementById('bid-inline-cancel');
      var msgEl       = document.getElementById('bid-inline-msg');
      if (!inlineWrap || !inputAmount || !btnOk || !btnCancel || !msgEl) return;

    function showInline() {
      var min = extractPrice(priceEl) || 0;
      inputAmount.min = String(min);
      inputAmount.step = '1';
      inputAmount.value = min ? min : '';
      inputAmount.readOnly = false;
      inputAmount.removeAttribute('readonly');
      msgEl.textContent = '';
      msgEl.className = 'bid-inline__msg';

      btnPlace.classList.add('hidden');
      inlineWrap.style.display = 'block';
      inputAmount.focus();
      inputAmount.select();
    }

    function hideInline() {
      inlineWrap.style.display = 'none';
      btnPlace.classList.remove('hidden');
      msgEl.textContent = '';
      msgEl.className = 'bid-inline__msg';
    }

    function setMsg(text, ok){
      msgEl.textContent = text || '';
      msgEl.className = 'bid-inline__msg ' + (ok ? 'bid-inline__msg--ok' : 'bid-inline__msg--err');
    }

    // Fetch latest (most recent) bid for this auction
    async function fetchLatestBid(auctionId, apiBase){
      const r = await fetch(`${apiBase}/api/auctions/${encodeURIComponent(auctionId)}/bids`, {
        headers: window.staAuctionHeaders ? window.staAuctionHeaders() : { Accept:'application/json' }, mode:'cors'
      });
      if (!r.ok) return null;
      const payload = await r.json();
      const rows = pickArray(payload);
      if (!rows.length) return null;

      // sort by placed_at (desc); fall back to amount desc
      rows.sort((a,b)=>{
        const ta = Date.parse(attr(a,'placed_at')||'') || 0;
        const tb = Date.parse(attr(b,'placed_at')||'') || 0;
        if (tb !== ta) return tb - ta;
        const aa = parseFloat(attr(b,'amount')||0), ab = parseFloat(attr(a,'amount')||0);
        return aa - ab;
      });
      return rows[0]; // most recent
    }

    // Compare latest bid owner vs current customer
    function isSameBidder(latestBid, currentId, currentEmail){
      if (!latestBid) return false;
      const id = String(attr(latestBid,'platform_customer_id') || '');
      const email =
        attr(latestBid,'platform_customer_email') ||
        attr(latestBid,'email') ||
        (latestBid.customer && latestBid.customer.email) || '';

      if (currentId && id && String(currentId) === String(id)) return true;
      if (currentEmail && email && String(currentEmail).toLowerCase() === String(email).toLowerCase()) return true;
      return false;
    }


    async function submitBid() {
      try {
        btnOk.disabled = true;
        setMsg('', true);

        var min = parseFloat(inputAmount.min) || 0;
        var amount = Math.round(parseFloat(String(inputAmount.value).replace(/[^0-9.]/g, '')));
        if (!isFinite(amount) || amount <= 0) {
          setMsg('Enter a valid bid amount.', false);
          btnOk.disabled = false;
          return;
        }
        if (amount < min) {
          setMsg('Bid must be at least ' + formatLike(priceEl, min) + '.', false);
          btnOk.disabled = false;
          return;
        }

        // find a live auction id for this product
        var auctionId = window.staResolveAuctionId ? window.staResolveAuctionId() : '';
        if (!auctionId) {
          try {
            auctionId = new URL(location.href).searchParams.get('auction_id') || '';
          } catch (e) {}
        }
        if (!auctionId) {
          setMsg('No live auction for this product right now.', false);
          btnOk.disabled = false;
          return;
        }

        // ---- if this customer already holds the latest bid, allow re-bidding,
        //      but only when the new amount is higher than their current latest bid ----
        var currentEmail =
          (window.Shopify && window.Shopify.customer && window.Shopify.customer.email) || '';
        var latest = await fetchLatestBid(auctionId, API_BASE);
        var raisingOwnBid = isSameBidder(latest, customerId, currentEmail);
        if (raisingOwnBid) {
          var latestAmount = parseFloat(attr(latest, 'amount')) || 0;
          if (amount <= latestAmount) {
            setMsg('You already have the latest bid. Enter an amount higher than ' + formatLike(priceEl, latestAmount) + '.', false);
            btnOk.disabled = false;
            return;
          }
        }

        // payload
        var body = {
          max_bid: { amount: `${amount}`, platform_customer_id: customerId || null },
          customer: { first_name:first, last_name:last, email:email },
        };

        var submitPromise = window.staPostMaxBid
          ? window.staPostMaxBid(auctionId, body)
          : fetch(API_BASE + '/api/auctions/' + encodeURIComponent(auctionId) + '/max_bids', {
              method: 'POST',
              headers: Object.assign({}, auctionHeaders, { 'Content-Type':'application/json' }),
              body: JSON.stringify(body),
            }).then(function (r) {
              return r.json().then(function (data) {
                return { ok: r.ok, status: r.status, data: data };
              });
            });

        const result = await submitPromise;
        const res = { ok: result.ok, status: result.status };
        const data = result.data || {};
        if (!res.ok) {
          // The verification gate refuses with a reason and somewhere to go.
          if (data && data.reason === 'card_expired') {
            msgEl.className = 'bid-inline__msg bid-inline__msg--err';
            msgEl.textContent = (data.error || 'Your card on file has expired.') + ' ';
            var updateLink = document.createElement('a');
            updateLink.href = replaceCardUrl();
            updateLink.textContent = 'Update card';
            msgEl.appendChild(updateLink);
            btnOk.disabled = false;
            return;
          }

          if (data && (data.reason === 'not_verified' || data.reason === 'not_signed_in')) {
            var here = window.staReturn ? window.staReturn.currentPath() : '';
            var href = window.staReturn
              ? window.staReturn.withReturn(data.verify_url || '/pages/verify-to-bid', here)
              : (data.verify_url || '/pages/verify-to-bid');
            var loginHref = window.staReturn
              ? window.staReturn.loginUrl(here)
              : '/customer_authentication/login?return_to=' + encodeURIComponent(here);
            msgEl.className = 'bid-inline__msg bid-inline__msg--err';
            msgEl.textContent = (data.error || 'Your account needs to be verified.') + ' ';
            var a = document.createElement('a');
            a.href = data.reason === 'not_signed_in' ? loginHref : href;
            a.textContent = data.reason === 'not_signed_in' ? 'Sign in' : 'Verify my account';
            msgEl.appendChild(a);
            btnOk.disabled = false;
            return;
          }

          setMsg(data?.detail || data?.error || data?.data?.errors?.[0]?.title || ('Bid failed (HTTP ' + res.status + ')'), false);
          btnOk.disabled = false;
          return;
        }

        // ✅ Instant UI updates (no reload)
        // 1) flip the price label to "Last bid price:" and paint the entered
        //    amount for instant feedback (reconciled with server truth below).
        var priceLabelEl = document.querySelector('[data-sta-auction-price-label]');
        if (priceLabelEl) priceLabelEl.textContent = 'Last bid price:';
        if (priceEl) {
          if (window.staSetMoneyEl) window.staSetMoneyEl(priceEl, amount);
          else priceEl.textContent = formatLike(priceEl, amount);
        }

        // 2) update bids count immediately, then sync from show API when available
        if (bidsCountEl) {
          var currentBids = parseInt((bidsCountEl.textContent || '').replace(/\D/g, ''), 10) || 0;
          setBidsCount(currentBids + 1);
        }
        refreshBidsCountFromShow(auctionId);

        // 3) reconcile label/price/count from the authoritative auction record.
        //    Max-bid (proxy) pricing means the real current price can differ from
        //    the entered amount; repaint once the server has registered the bid.
        if (window.staRepaintAuctionPdp) {
          setTimeout(function () { window.staRepaintAuctionPdp(auctionId); }, 1200);
          setTimeout(function () { window.staRepaintAuctionPdp(auctionId); }, 4000);
        }

        // The engine broadcasts bid activity to everyone watching the lot, but
        // nothing that says "your bid went through" — so the bidder's own
        // receipt is raised here, landing in the same toast and bell as the rest.
        if (window.staNotifications && window.staNotifications.notify) {
          window.staNotifications.notify('bid_confirmed', {
            auction_id: auctionId,
            product_name: PRODUCT_TITLE,
            product_image_url: PRODUCT_IMAGE,
            raised: raisingOwnBid,
          });
        }

        setMsg(raisingOwnBid ? 'Maximum Bid updated' : 'Bid placed successfully! We’ll keep you updated in real time.', true);
        setTimeout(hideInline, 1200);
        // no location.reload()

      } catch (err) {
        console.error('[bid] submit error', err);
        setMsg('Network error. Please try again.', false);
      } finally {
        btnOk.disabled = false;
      }
    }



    // ---- Wire up events ----
    btnPlace.addEventListener('click', function (e) {
      e.preventDefault();
      showInline();
    });

    btnCancel.addEventListener('click', function () {
      hideInline();
    });

    btnOk.addEventListener('click', function () {
      submitBid();
    });

    // Enter to confirm, Esc to cancel
    inputAmount.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submitBid(); }
      if (e.key === 'Escape') { e.preventDefault(); hideInline(); }
    });

    }

    maybeGateByUrlAuctionIdThen(initPlaceBidUi);
  });
})();
